import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CurrentSiteIdStore } from './current-site-id.store';
import { TargetSite } from './target-site';

/**
 * Adds `X-Target-Site-Id` to every outgoing request so the backend can resolve the
 * current site without reading a cookie (the JWT cookie is HttpOnly, the site-id
 * cookie has been replaced by localStorage).
 */
@Injectable()
export class TargetSiteInterceptor implements HttpInterceptor {
  private readonly currentSiteIdStore = inject(CurrentSiteIdStore);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('X-Target-Site-Id')) {
      return next.handle(request);
    }

    const siteId = TargetSite.get() ?? this.currentSiteIdStore.get();
    if (!siteId) {
      return next.handle(request);
    }

    return next.handle(request.clone({ setHeaders: { 'X-Target-Site-Id': siteId.toString() } }));
  }
}
